<ion-content class="ion-padding activate-delegated-content">
  <!-- Silent landing: neutral spinner only while the consent link is fetched, then we
       redirect away. No text (avoids backend-caption dependency) and no error dialog. -->
  <div class="activate-delegated-spinner">
    <ion-spinner name="crescent"></ion-spinner>
  </div>
</ion-content>
